<script setup lang="ts">
import { computed } from "vue";

const page = usePage().value;
const fitnessTips = computed(() => page?.fitnessTips ?? []);
const currentSlide = ref(0);

const { isMobile } = useIsMobile();
const windowWidth = ref(0); // default value
const itemsToShow = ref(3.5);
const itemsToScroll = ref(1);
const wrapAround = ref(true);

function updateWidth() {
  if (process.client) {
    windowWidth.value = window.innerWidth;

    if (isMobile.value) {
      itemsToShow.value = 1;
    } else {
      itemsToShow.value = 3;
    }
  }
}

onMounted(() => {
  updateWidth();
  window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});
</script>

<template>
  <div id="fitnessTips">
    <header>
      <h2>Trekking Fitness Top Tips</h2>
    </header>

    <Carousel
      v-model="currentSlide"
      :items-to-show="itemsToShow"
      :items-to-scroll="itemsToScroll"
      :wrap-around="wrapAround"
    >
      <Slide v-for="(slide, index) in fitnessTips" :key="slide.id">
        <div class="carousel__item">
          <div class="tip-image">
            <NuxtPicture
              preload
              :src="slide?.tipImage?.url"
              :width="slide?.tipImage?.width"
              :height="slide?.tipImage?.height"
              :alt="slide?.tipImage?.alt"
              sizes="sm:200px md:300px lg:400px"
            />
          </div>
          <div class="tip-text">
            <h3>
              <span>{{ index + 1 }}</span
              ><span>{{ slide.tipHeading }}</span>
            </h3>
            <div v-html="slide.tip" />
          </div>
        </div>
      </Slide>
      <template #addons>
        <Navigation />
        <Pagination />
      </template>
    </Carousel>

    <div v-html="page?.tipsText" />
  </div>
</template>
